export default __webpack_public_path__ + "static/media/drum-machine-desktop.7d022477.png";